import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center bg-brand-dark-gray rounded-xl px-5 py-4 pb-5 space-y-8" }
const _hoisted_2 = { class: "flex flex-col w-full items-center space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col py-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Join Pineapple Premium"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, "Sign up to get verified, access our premium features and enhance your user-experience. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "mx-auto w-full flex bg-brand-lime rounded-full px-8 h-12 font-medium text-xl text-brand-black transition-all" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Upgrade")
    ])
  ])
], -1)

import InAppSubscription from "@/components/InAppSubscription.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinPremiumCard',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(InAppSubscription, {
        class: "w-full",
        label: "Upgrade to Pineapple Premium"
      }, {
        body: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})